import { useNavigate } from 'react-router-dom';
import { getSortInfo } from 'src/services/languageSpanHelpers';
import { useBaseUrlStore, useLanguageStore } from 'src/StoreDataProvider';
import Accordion from '../../atoms/Accordion/Accordion';
import { AccordionSitemapCountryProps } from './accordionSitemapCountry.types';

const AccordionSitemapCountry: (
  props: AccordionSitemapCountryProps
) => JSX.Element = ({ sitemapCountry }) => {
  const navigate = useNavigate();
  const { path } = useBaseUrlStore();
  const { language } = useLanguageStore();

  return (
    <Accordion
      className="sitemap-container__list--accordion"
      title={sitemapCountry.country}
      iconActive="icon-pfeil-rechts"
      isActive={false}
      hierachy={4}
    >
      <ul>
        {sitemapCountry.projects
          .sort((a, b) => getSortInfo(a.projectName, b.projectName, language))
          .map((sitemapProject, innerPos) => {
            return (
              <li
                className={`sitemap-container__list--project  ${
                  innerPos === sitemapCountry.projects.length - 1
                    ? 'last-item'
                    : ''
                }`}
                key={`sitemap-container__list--project-${sitemapProject.id}-${innerPos}`}
              >
                <Accordion
                  className="singleProject"
                  title={sitemapProject.projectName}
                  iconActive="icon-pfeil-rechts"
                  isActive={false}
                  hierachy={4}
                  onClick={() =>
                    navigate(`/${path}/detail/${sitemapProject.id}`)
                  }
                />
              </li>
            );
          })}
      </ul>
    </Accordion>
  );
};

export default AccordionSitemapCountry;
